"use client";
import React from "react";
import { useRouter, usePathname } from "next/navigation";
import ButtonAnimated from "@/components/ButtonAnimated/ButtonAnimated";
import "@/common/Common.css";

export const Banner = ({
  title = "Auf los geht’s los mit Autoeinfachlos!",
  h2,
  h3,
  removeContent,
  className,
  link = "/", // ✅ NEW: pass any link here (internal/external/#hash)
}) => {
  const router = useRouter();
  const pathname = usePathname();

  const handleButtonClick = () => {
    if (!link) return;

    // External / special protocols
    const isExternal =
      /^https?:\/\//i.test(link) ||
      /^mailto:/i.test(link) ||
      /^tel:/i.test(link);

    if (isExternal) {
      window.location.href = link;
      return;
    }

    // Hash-only link like "#section" -> stay on same page and scroll
    if (link.startsWith("#")) {
      const hash = link.slice(1);
      const el = document.getElementById(hash);
      if (el) el.scrollIntoView({ behavior: "smooth" });
      else window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    // Internal link handling (supports "/path?x=1#section")
    const [pathWithQuery, hash] = link.split("#");
    const path = (pathWithQuery || "/").split("?")[0] || "/";

    // If already on that path, scroll instead of re-routing
    if (path === pathname) {
      if (hash) {
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: "smooth" });
        else window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    router.push(link);
  };

  return (
    <div className={`${className} Banner`}>
      <div className="Banner-bg" />

      {!removeContent && (
        <>
          {h2 ? (
            <h2 className="Banner-title">{title}</h2>
          ) : h3 ? (
            <h3 className="Banner-title">{title}</h3>
          ) : (
            <h2 className="Banner-title">{title}</h2>
          )}

          <ButtonAnimated
            text="Auto Bewerten"
            hideChevron={true}
            width="348px"
            className="Banner-Button"
            onClick={handleButtonClick}
          />
        </>
      )}
    </div>
  );
};
